import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const NewItemsOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/new-item-update" urlone="/NewItem-bussines-Profile" deleteurl="/NewItem-bussines-Profile"/>
        </div>
    )
}
export default NewItemsOwnerView;